module.exports = __webpack_public_path__ + "static/media/map.b0da9e3a.jpg";